import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LegalFooterComponent } from '../shared/legal-footer/legal-footer.component';

@Component({
  selector: 'app-child-safety',
  standalone: true,
  imports: [CommonModule, RouterModule, LegalFooterComponent],
  templateUrl: './child-safety.component.html',
  styleUrls: ['../shared/legal-pages.styles.scss', './child-safety.component.scss']
})
export class ChildSafetyComponent {
  currentDate = new Date();

  constructor(private router: Router) {}

  goBack() {
    this.router.navigate(['/']);
  }
}
